export default __webpack_public_path__ + "static/media/background.8d3984d0.jpg";